import { useCallback, useEffect, useState } from 'react';
import API_URL from '@/config/api';

export function useMyPlan() {
  const [plan, setPlan] = useState(null);
  const reload = useCallback(async () => {
    try {
      const r = await fetch(`${API_URL}/api/billing/me`, { credentials: 'include' });
      if (r.ok) setPlan(await r.json());
    } catch { /* ignore */ }
  }, []);
  useEffect(() => { reload(); }, [reload]);
  const has = (feature) => !!plan?.tier?.features?.[feature];
  return { plan, reload, has, loaded: plan !== null };
}

export const isUpgradeError = (err) => /Pro feature|upgrade_required|Upgrade to unlock/i.test(err?.message || '');
